<template>
	<div>
		<newsCenList :list="newsList"></newsCenList>
		<div class="newsPagination ">
			<el-pagination :page-size="limit"  layout="prev, pager, next" :total="allNum" @current-change="goPagin">
			</el-pagination>
		</div>
		<!-- <div class="newsPagination ">
		<div class="newsPaginationFor" v-for="(item,index) in allArr" :key="index" @click="goPagin(item)">
			<div class="newsPaginationForOne"  :class="page==item?'newsPaginationThree':'newsPaginationOne'" v-if="index==0">
				{{$t('LED光源高续航')}}
			</div>
			<div class="newsPaginationForOne" :class="page==item?'newsPaginationThree':'newsPaginationOne'" v-else-if="index==(allArr - 1)">
				{{$t('高兼容性')}}
			</div>
			<div class="newsPaginationForOne"  :class="page==item?'newsPaginationFour':'newsPaginationTwo'"  v-else>
				{{item}}
			</div>
		</div>
	</div> -->
	</div>
</template>

<script>
	import newsCenList from "./newsCenList"
	export default {
		components: {
			newsCenList
		},
		data() {
			return {
				newsList: [
					// {
					// 	img:require("@/assets/content/newImg.png"),
					// 	name:'AQ-300 4K超高清内镜系统正式发布',
					// 	cen:'[The Endless Frontier 无尽的前沿],澳华全新一代旗舰产品，AQ-300 4K超高清内镜系统正式发布',
					// 	time:'2022-11-01'
					// },
					// {
					// 	img:require("@/assets/content/newImg.png"),
					// 	name:'AQ-300 4K超高清内镜系统正式发布',
					// 	cen:'[The Endless Frontier 无尽的前沿],澳华全新一代旗舰产品，AQ-300 4K超高清内镜系统正式发布',
					// 	time:'2022-11-01'
					// },
					// {
					// 	img:require("@/assets/content/newImg.png"),
					// 	name:'AQ-300 4K超高清内镜系统正式发布',
					// 	cen:'[The Endless Frontier 无尽的前沿],澳华全新一代旗舰产品，AQ-300 4K超高清内镜系统正式发布',
					// 	time:'2022-11-01'
					// },
				],
				allNum: 0,
				limit: 5,
				page: 1
			}
		},
		computed: {
			allArr() {
				return Math.ceil(this.allNum / this.limit);
			}
		},
		mounted() {

		},
		methods: {
			goPagin(e) {
				this.page = e;
				this.$emit('changePage', this.page)
			},
			setList(e) {
				this.newsList = e.list;
				this.allNum = e.count
			}
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.newsPagination {
		display: flex;
		justify-content: center;
		align-items: center;
		padding-bottom: 160px;
		padding-top: 50px;
		width: 1200px;
		margin: 0 auto;

		.newsPaginationFor:not(:last-child) {
			margin-right: 54px;
		}

		.newsPaginationFor {
			.newsPaginationForOne {
				border-radius: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
				
				font-weight: 400;
				cursor: pointer;
			}

			.newsPaginationOne {
				background-color: #f4f4f4;
				width: 50px;
				height: 50px;
				font-size: 20px;
				color: #ACACAC;
			}

			.newsPaginationTwo {
				width: 20px;
				height: 20px;
				background-color: #f4f4f4;
				font-size: 17px;
				
				font-weight: 400;
				color: #ACACAC;
			}

			.newsPaginationThree {
				width: 50px;
				height: 50px;
				background-color: #848484;
				font-size: 20px;
				color: #FFFFFF;
			}

			.newsPaginationFour {
				width: 20px;
				height: 20px;
				background-color: #848484;
				font-size: 17px;
				
				font-weight: 400;
				color: #fff;
			}
		}
	}
	
	@media screen and (max-width:1200px) {
		.newsPagination{
			padding-bottom: 30px !important;
			padding-top: 30px !important;
			width: 100% !important;
		}
	}
</style>
<style lang="scss">
	.el-pagination{
		display: flex;
	}
	.el-pager .number{
		width: 25px !important;
		height: 25px !important;
		line-height: 25px;
		min-width: 0;
	}
	.el-pager .active{
		color: #fff !important;
		background: #848484 !important;
		border-radius: 100%;
		
	}
</style>